<script>
import moment from 'moment'
import EditableListView from '@/components/common/EditableListView'
import MultipleProfilePicker from '@/components/profile/MultipleProfilePicker'
import { mapGetters, mapState } from 'vuex'
import SelfServiceModeler from '@/components/self-service/SelfServiceModeler'
import InputProposal from '../common/InputProposal'
import InputConstant from '../common/InputConstant'
import axios from 'axios'
import { botApi } from '../../api'
import { identitiesApi } from '../../api'
export default {
  name: 'BotCard.vue',
  props: {
    hexId: String
  },
  data() {
    return {
      isCard: false,
      bot: null,
      hideInARTimeline: false,
      editName: false,
      editDescription: false,
      editBpmn: false,
      editHive: false,
      editEmailList: false,
      botUpdating: false,
      botProfilesUpdating: false,
      botTemplateUpating: false,
      botWorkflowsUpdating: false,
      botIdentitiesUpdating: false,
      activeConfirmDialog: false,
      showProposal: false,
      serviceCreation: false,
      selfServiceHexId: null,
      hasSelfService: false,
      name: '',
      description: '',
      emailList: [],
      emailRules: [
        v => (v.length > 0 ? /.+@.+/.test(v) || 'E-mail must be valid' : !!v)
      ],
      active: false,
      hiveTypeSelected: '',
      hiveSelected: {},
      bpmnId: '',
      searchAttributes: ['name', 'description', 'hexId'],
      botIdentities: [],
      identities: []
    }
  },

  computed: {
    ...mapState({
      botsTemplate: state => state.bots.botsTemplate,
      botProfiles: state => state.bots.botProfiles,
      // botIdentities: state => state.bots.botIdentities,
      botWorkflows: state => state.bots.botWorkflows,
      botHive: state => state.bots.botHive,
      hiveTypes: state => state.enums.hiveTypes,
      hives: state => state.hives.hives,
      identities: state => state.identities.identities
    }),
    ...mapGetters({
      can: 'can'
    }),
    filteredHivesForHiveType() {
      return this.hives.filter(hive => hive.hiveType === this.hiveTypeSelected)
    }
  },

  watch: {
    hexId() {
      this.init(this.hexId)
    },
    bot() {
      this.name = this.bot.name
      this.description = this.bot.description
      this.active = this.bot.active
      this.hideInARTimeline = this.bot.hideInARTimeline
      this.bpmnId = this.bot.bpmnId
      this.emailList = this.bot.supportEmailLists
        ? this.bot.supportEmailLists.join()
        : []
    },
    botHive() {
      this.hiveSelected = this.botHive[this.bot.hexId]
      this.hiveTypeSelected = this.botHive[this.bot.hexId]
        ? this.botHive[this.bot.hexId].hiveType
        : ''
    },
    hideInARTimeline() {
      if (this.hideInARTimeline !== this.bot.hideInARTimeline)
        this.setHideInARTimeline()
    }
  },

  created() {
    if (this.hexId || this.$router.currentRoute.name === 'bot-card') {
      if (this.$router.currentRoute.name === 'bot-card') {
        this.isCard = true
      } else {
        this.isCard = false
      }
      const id = this.$route.params.hexId || this.hexId
      this.init(id)
    }
  },

  methods: {
    gotoList() {
      this.$router.replace({ name: 'bot-list' }).catch()
    },
    init(id) {
      this.botUpdating = true
      axios
        .get(`/api/v1/bots/${id}`)
        .then(response => {
          this.bot = response.data
          this.getAssociations()
          this.checkSelfService()
          this.botUpdating = false
        })
        .catch(error => {
          console.log(error)
          this.botUpdating = false
        })
    },
    async gotoSource() {
      this.$router
        .push({
          name: 'self-service-detail',
          params: { hexId: this.selfServiceHexId }
        })
        .catch()
    },

    async checkSelfService() {
      this.selfServiceHexId = null
      try {
        let response = await this.$store.dispatch(
          'fetchBotSelfService',
          this.bot.hexId
        )
        this.selfServiceHexId = response.data.hexId
        this.hasSelfService = true
      } catch (e) {
        console.log(e)
        this.hasSelfService = false
      }
    },

    getAssociations() {
      this.getBotProfiles()
      this.getBotTemplate()
      this.getBotIdentities()
      this.getBotHive()
      this.getBotWorkflows()
      if (this.identities && this.identities.length === 0) {
        this.$store.dispatch('fetchIdentities')
      }
    },

    async getBotTemplate() {
      this.botTemplateUpating = true
      try {
        await this.$store.dispatch('fetchBotTemplate', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot Template',
          description: e.response.data.message,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpating = false
    },

    async getBotWorkflows() {
      this.botWorkflowsUpdating = true
      try {
        await this.$store.dispatch('fetchBotWorkflows', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Workflow(s) for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Unable to fetch Workflow(s) for the Bot',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botWorkflowsUpdating = false
    },

    async getBotProfiles() {
      this.botProfilesUpdating = true
      try {
        await this.$store.dispatch('fetchBotProfiles', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Profile(s) for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Unable to fetch Profile(s) for the Bot',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botProfilesUpdating = false
    },

    async getBotIdentities() {
      this.botIdentitiesUpdating = true
      try {
        // await this.$store.dispatch('fetchBotIdentities', this.bot)
        this.botIdentities = await botApi.fetchBotIdentities(this.bot)
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Identity(s) for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Unable to fetch Identity(s) for the Bot',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botIdentitiesUpdating = false
    },

    async getBotHive() {
      this.botUpdating = true
      try {
        await this.$store.dispatch('fetchBotHive', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Unable to fetch Agent for the Bot',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpdating = false
    },

    async setHideInARTimeline() {
      this.botUpdating = true
      try {
        await this.$store.dispatch('updateBot', {
          body: { hideInARTimeline: this.hideInARTimeline },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot updated successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot update failed!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpdating = false
    },

    async setActive(status) {
      this.botUpdating = true
      this.activeConfirmDialog = false
      if (status) {
        try {
          await this.$store.dispatch('updateBot', {
            body: { active: this.active },
            hexId: this.bot.hexId
          })
          let message = ''
          if (this.active) {
            message = 'Bot activated Successfully'
          } else {
            message = 'Bot de-activated Successfully'
          }
          await this.$store.dispatch('directNotification', {
            message: message,
            type: 'success',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } catch (e) {
          let message = ''
          if (this.active) {
            message = 'Bot activation Failed'
          } else {
            message = 'Bot de-activation Failed'
          }
          await this.$store.dispatch('directNotification', {
            message: message,
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.resetActive()
        }
      } else {
        this.resetActive()
      }
      this.botUpdating = false
    },

    resetActive() {
      this.active = this.bot.active
    },

    async setConstants(value) {
      this.botUpdating = true
      try {
        await this.$store.dispatch('updateBot', {
          body: { constants: value },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot constant(s) updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot constant(s) update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpdating = false
    },

    async setProposals(value) {
      this.botUpdating = true
      try {
        await this.$store.dispatch('updateBot', {
          body: { proposals: value },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot proposal updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot proposal update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpdating = false
    },

    async setName() {
      this.botUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updateBot', {
          body: { name: this.name },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.botUpdating = false
    },

    resetName() {
      this.editName = false
      this.name = this.bot.name
    },

    async setDescription() {
      this.botUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateBot', {
          body: { description: this.description },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot description changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot description change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.botUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.bot.description
    },

    async setEmailList() {
      if (this.$refs.emailForm.validate()) {
        this.botUpdating = true
        this.editEmailList = false
        try {
          await this.$store.dispatch('updateBot', {
            body: { supportEmailLists: this.emailList.split(',') },
            hexId: this.bot.hexId
          })
          await this.$store.dispatch('directNotification', {
            message: 'Bot support email(s) list updated Successfully',
            type: 'success',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            message: 'Bot support email(s) list updation Failed',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.resetEmailList()
        }
        this.botUpdating = false
      }
    },

    resetEmailList() {
      this.editEmailList = false
      this.emailList = this.bot.supportEmailLists.join()
    },

    async setBpmn() {
      this.botUpdating = true
      this.editBpmn = false
      try {
        await this.$store.dispatch('updateBot', {
          body: { bpmnId: this.bpmnId },
          hexId: this.bot.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot BPMN assignment changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot BPMN assignment change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetBpmn()
      }
      this.botUpdating = false
    },

    resetBpmn() {
      this.editBpmn = false
      this.bpmnId = this.workflow.bpmnId
    },

    async setHive() {
      this.botUpdating = true
      this.editHive = false
      try {
        await this.$store.dispatch('setHiveToBot', {
          hiveId: this.hiveSelected.hexId,
          bot: this.bot
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Agent updated Successfully',
          description: 'Agent updated Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Agent update Failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Unable to update Agent'
        })
      }
      try {
        await this.$store.dispatch('fetchBotHive', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpdating = false
    },

    resetHive() {
      this.editHive = false
      this.hiveSelected = this.botHive[this.bot.hexId]
    },

    async setProfiles(profileIds) {
      this.botProfilesUpdating = true
      try {
        await this.$store.dispatch('addProfilesToBot', {
          profileIds,
          bot: this.bot
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Profile(s) updated for Bot Successfully',
          description: 'Profile(s) updated for Bot Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Profile(s) update Failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        await this.$store.dispatch('fetchBotProfiles', this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Fetching Profile(s) for the Bot Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botProfilesUpdating = false
    },

    async identitiesAdded(identities) {
      this.botIdentitiesUpdating = true
      try {
        // await this.$store.dispatch('addIdentitiesToBot', {
        //   identities,
        //   bot: this.bot
        // })
        await botApi.addIdentitiesToBot(identities, this.bot)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Identity(s) updated for Bot Successfully',
          description: 'Identity(s) updated for Bot Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Identity(s) update Failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchBotIdentities', this.bot)
        this.botIdentities = await botApi.fetchBotIdentities(this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Identity(s) for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botIdentitiesUpdating = false
    },

    async identitiesDeleted(identities) {
      this.botIdentitiesUpdating = true
      try {
        // await this.$store.dispatch('deleteIdentitiesFromBot', {
        //   identities,
        //   bot: this.bot
        // })
        await Promise.all(
          identities.map(identitie =>
            botApi.deleteIdentitiesFromBot(identitie, this.bot)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Identity(s) deleted for the Bot Successfully',
          description: 'Identity(s) deleted for the Bot Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Identity(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchBotIdentities', this.bot)
        this.botIdentities = await botApi.fetchBotIdentities(this.bot)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Identity(s) for the Bot',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botIdentitiesUpdating = false
    },
    async search(query) {
      try {
        const { data } = await identitiesApi.fetchIdentities(
          query && `?search=${query}&size=20&page=1`
        )
        this.identities = data._embedded.identities
      } catch (error) {
        console.log(error)
      }
    }
  },

  components: {
    EditableListView,
    SelfServiceModeler,
    MultipleProfilePicker,
    InputProposal,
    InputConstant
  }
}
</script>

<template>
  <v-card class="beez-card" v-if="bot">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >{{ bot.name }}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom v-if="isCard">
        <v-btn icon flat slot="activator" @click="gotoList">
          <v-icon>list</v-icon>
        </v-btn>
        <span>Goto Bot List</span>
      </v-tooltip>
      <v-tooltip bottom v-if="hasSelfService">
        <v-btn icon flat slot="activator" @click="gotoSource">
          <v-icon>link</v-icon>
        </v-btn>
        <span>Goto source Automation service</span>
      </v-tooltip>
      <v-dialog
        max-width="60%"
        v-model="serviceCreation"
        v-if="can('BOT_SERVICE')"
      >
        <v-tooltip bottom slot="activator" v-if="!hasSelfService">
          <v-btn icon @click.stop="serviceCreation = true" slot="activator">
            <v-icon>add</v-icon>
          </v-btn>
          <span class="ml-2"> Register as an Automation Service </span>
        </v-tooltip>

        <template>
          <v-card>
            <self-service-modeler
              :selected-item="bot"
              @cancel="serviceCreation = false"
            />
          </v-card>
        </template>
      </v-dialog>
      <v-dialog
        v-model="activeConfirmDialog"
        persistent
        max-width="290"
        :class="{ 'pull-right': $vuetify.breakpoint.mdAndUp }"
        v-if="can('BOT_STATUS')"
      >
        <input
          class="apple-switch"
          type="checkbox"
          label="Active"
          color="success"
          v-model="active"
          slot="activator"
        />
        <v-card style="border-radius: 5px;">
          <div v-if="!active">
            <v-card-text class="subheading"
              >Confirm de-activating the Bot - {{ bot.name }}
            </v-card-text>
          </div>
          <div v-else>
            <v-card-text class="subheading"
              >Confirm activating the Bot - {{ bot.name }}
            </v-card-text>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn flat icon @click="setActive(false)">
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn flat icon class="primary" @click="setActive(true)">
              <v-icon>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      color="accent"
      class="ma-0"
      height="5"
      :active="botUpdating"
    />
    <div class="pa-3">
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex grow>
          <v-text-field
            :outline="$vuetify.dark"
            color="secondary"
            label="Name"
            v-model="name"
            :readonly="!editName"
          >
            <template slot="append">
              <template v-if="editName">
                <v-icon @click="resetName">clear</v-icon>
                <v-icon @click="setName">save</v-icon>
              </template>
              <template v-else>
                <v-icon v-if="can('BOT_NAME_EDIT')" @click="editName = true"
                  >edit
                </v-icon>
              </template>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex grow>
          <v-text-field
            class="pl-1"
            :outline="$vuetify.dark"
            color="secondary"
            label="BPMN Identifier"
            v-model="bpmnId"
            :readonly="!editBpmn"
          >
            <template slot="append">
              <template v-if="editBpmn">
                <v-icon @click="resetBpmn">clear</v-icon>
                <v-icon @click="setBpmn">save</v-icon>
              </template>
              <template v-else>
                <v-icon v-if="can('BOT_BPMN_EDIT')" @click="editBpmn = true"
                  >edit
                </v-icon>
              </template>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-textarea
        :outline="$vuetify.dark"
        no-resize
        color="secondary"
        label="Description"
        v-model="description"
        :readonly="!editDescription"
        :rows="1"
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <template v-else>
            <v-icon v-if="can('BOT_DES_EDIT')" @click="editDescription = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-textarea>
      <v-switch
        label="Hide in Automation Request timeline"
        v-model="hideInARTimeline"
      />
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex grow>
          <v-select
            :outline="$vuetify.dark"
            color="secondary"
            :items="hiveTypes"
            item-text="friendlyName"
            item-value="key"
            v-model="hiveTypeSelected"
            label="Agent Type"
            :readonly="!editHive"
            disabled
          >
          </v-select>
        </v-flex>
        <v-flex grow>
          <v-text-field
            class="pl-1"
            :outline="$vuetify.dark"
            color="secondary"
            label="Agent"
            v-model="hiveSelected.name"
            readonly
            v-if="hiveSelected && filteredHivesForHiveType.length === 0 && !editHive"
            disabled
            ></v-text-field>
          <v-select
            v-else
            class="pl-1"
            :outline="$vuetify.dark"
            color="secondary"
            :items="filteredHivesForHiveType"
            item-text="name"
            item-value="hexId"
            v-model="hiveSelected"
            label="Agent"
            return-object
            :readonly="!editHive"
            disabled
          >
            <!--            Todo: To be enabled when hives can be changed for a bot-->
            <!--            <template slot="append-outer">-->
            <!--              <template v-if="editHive">-->
            <!--                <v-icon @click="resetHive">clear</v-icon>-->
            <!--                <v-icon @click="setHive">save</v-icon>-->
            <!--              </template>-->
            <!--              <v-icon v-else @click="editHive=true">edit</v-icon>-->
            <!--            </template>-->
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-flex grow>
          <v-form ref="emailForm">
            <v-text-field
              class="pl-1"
              :outline="$vuetify.dark"
              color="secondary"
              label="Support Email List"
              v-model="emailList"
              :rules="emailRules"
              :readonly="!editEmailList"
            >
              <template slot="append">
                <template v-if="editEmailList">
                  <v-icon @click="resetEmailList">clear</v-icon>
                  <v-icon @click="setEmailList">save</v-icon>
                </template>
                <template v-else>
                  <v-icon
                    v-if="can('BOT_EMAIL_EDIT')"
                    @click="editEmailList = true"
                    >edit
                  </v-icon>
                </template>
              </template>
            </v-text-field>
          </v-form>
        </v-flex>
      </v-layout>
      <!-- Todo: Add Can Function for Privileges -->
      <div
        v-if="
          Array.isArray(botsTemplate[bot.hexId]) &&
            botsTemplate[bot.hexId].length &&
            can('BOT_BOTTEMPLATE')
        "
      >
        <v-card class="fill-height">
          <v-layout column fill-height>
            <v-flex shrink>
              <v-toolbar dense card class="elevation-2">
                <v-toolbar-title class="body-2 beez-bold "
                  >Bot Template
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-progress-linear
                indeterminate
                class="ma-0"
                color="accent"
                height="5"
                :active="botTemplateUpating"
              />
            </v-flex>
            <v-flex grow>
              <transition name="bounce" mode="out-in">
                <v-list
                  two-line
                  key="view-bot-list"
                  style="max-height: 520px"
                  class="scroll-y"
                >
                  <template v-for="(botTemplate, i) in botsTemplate[bot.hexId]">
                    <v-hover :key="i + 'template'">
                      <v-list-tile-content slot-scope="{ hover }">
                        <v-container fulid>
                          <v-layout row>
                            <v-flex xs1>
                              <v-avatar size="40">
                                <img src="/images/Bot.svg" alt="link" />
                              </v-avatar>
                            </v-flex>
                            <v-flex xs10 pl-3>
                              <v-list-tile-title
                                >{{ botTemplate.name }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title
                                >{{ botTemplate.description }}
                              </v-list-tile-sub-title>
                            </v-flex>
                            <v-flex xs1 class="text-xs-right">
                              <v-tooltip bottom>
                                <v-btn
                                  v-if="hover"
                                  slot="activator"
                                  icon
                                  flat
                                  small
                                  :to="{
                                    name: 'bot-template-detail',
                                    params: { hexId: botTemplate.hexId }
                                  }"
                                >
                                  <v-icon>link</v-icon>
                                </v-btn>
                                <span>Quick Link</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-list-tile-content>
                    </v-hover>
                  </template>
                </v-list>
              </transition>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div class="py-4" v-if="can('BOT_INPUT_PROPOSAL')">
        <input-proposal
          :key="bot.hexId + 'input-render'"
          :input-proposal="bot.proposals"
          @save="setProposals"
        />
      </div>
      <div class="pb-4" v-if="can('BOT_CONSTANTS')">
        <input-constant
          :key="bot.hexId + 'constant-render'"
          :input-constant="bot.constants"
          @save="setConstants"
        />
      </div>
      <multiple-profile-picker
        @finish="setProfiles"
        :outer-updating="botProfilesUpdating"
        :value="botProfiles[bot.hexId]"
      />

      <div class="pt-4">
        <editable-list-view
          :selectedItems="botIdentities"
          :allItems="identities"
          title="Identities"
          :updating="botIdentitiesUpdating"
          @added="identitiesAdded"
          @deleted="identitiesDeleted"
          :key="'identity -' + bot.hexId"
          :search-attributes="searchAttributes"
          @queryChanged="query => search(query)"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Identities.
          </template>

          <template
            :slot="slotName"
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            slot-scope="slotProps"
          >
            <v-hover :key="i + 'identity'">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-list-tile-avatar :key="i + 'avatar'">
                        <vue-letter-avatar
                          :name="slotProps.item.name"
                          size="40"
                          :rounded="true"
                        />
                      </v-list-tile-avatar>
                    </v-flex>
                    <v-flex grow>
                      <v-list-tile-title
                        >{{ slotProps.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          icon
                          flat
                          small
                          :to="{
                            name: 'identity-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>

      <div
        class="py-4"
        v-if="
          Array.isArray(botWorkflows[bot.hexId]) &&
            botWorkflows[bot.hexId].length &&
            can('BOT_WORKFLOW')
        "
      >
        <v-card class="fill-height">
          <v-layout column fill-height>
            <v-flex shrink>
              <v-toolbar dense card class="elevation-2">
                <v-toolbar-title class="body-2 beez-bold "
                  >Workflows
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-progress-linear
                indeterminate
                class="ma-0"
                color="accent"
                height="5"
                :active="botWorkflowsUpdating"
              />
            </v-flex>
            <v-flex grow>
              <transition name="bounce" mode="out-in">
                <v-list
                  two-line
                  key="view-workflow-list"
                  style="max-height: 760px"
                  class="scroll-y"
                >
                  <template v-for="(workflow, i) in botWorkflows[bot.hexId]">
                    <v-hover :key="i + 'workflow'">
                      <v-list-tile-content slot-scope="{ hover }">
                        <v-container fulid>
                          <v-layout row>
                            <v-flex shrink pl-3>
                              <v-avatar size="40">
                                <img src="/images/Workflow.svg" alt="link" />
                              </v-avatar>
                            </v-flex>
                            <v-flex grow pl-3>
                              <v-list-tile-title
                                >{{ workflow.name }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title
                                >{{ workflow.description }}
                              </v-list-tile-sub-title>
                            </v-flex>
                            <v-flex shrink>
                              <v-tooltip bottom>
                                <v-btn
                                  v-if="hover"
                                  slot="activator"
                                  icon
                                  flat
                                  small
                                  :to="{
                                    name: 'workflow-detail',
                                    params: { hexId: workflow.hexId }
                                  }"
                                >
                                  <v-icon>link</v-icon>
                                </v-btn>
                                <span>Quick Link</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-list-tile-content>
                    </v-hover>
                  </template>
                </v-list>
              </transition>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<style scoped></style>
